const Form011EN = {
    stepName: {
        Notes: "Notes",
        SectionA: "Personal Particulars",
        SectionB: "Language Proficiency",
        SectionC: "Employment",
        ExchangeProgramme: "Exchange Programme, Interests and Hobbies",
        FurtherInformation: "Further Information",
        Declaration: "Declaration",
        Consent: "Parental / Guardian’s Consent",
        Confirmation: "Confirmation",
    },
    title: {
        note: "Note",
        collectionPersonal: "Collection of Personal Data",
        languageProficiency: "(B) Language Proficiency",
        languageProficiencyNote:
            "(a) Language Standard",
        employment: "(C) Employment",
        personalParticulars: "(A) Personal Particulars",
        hkPersonTitle: "Person to be contacted in Hong Kong",
        exchangeProgramme: "(D) Exchange Programme",
        exchangeProgrammeTitle:
            "Have you ever led any other student exchange programme(s)?",
        exchangeProgrammeTableTitle:
            "If Yes, please provide information below.",
        InterestsAndHobbies: "(E) Interests and Hobbies",
        InterestsAndHobbiesTableTitle:
            "State your interests and hobbies below and attach a copy of the supporting document(s), if any:",
        part2: "Part II",
        part2title:
            "Recommendations - to be completed by the Principal of the nominating school",
        undertakeTitle: `I understand the selection of teacher-chaperons is independent of the student-delegates. If my teacher
        nominee is selected, notwithstanding of whether the student I also nominated for the JENESYS Programme (if
        any) is selected or not, I will undertake to release the teacher from {{undertakeDate}} inclusive to join the exchange visit. I will remind him / her to attend all the activities and discharge all the duties
        as required.`,
        furtherInformation: "(F) Further Information",
        declaration: "(G) Declaration",
    },
    label: {
        japanese: "Japanese",
        english: "English",
        putonghua: "Putonghua",
        proficiencyOptions: {
            fluent: "Fluent",
            canExpress: "A Little",
            cannotSpeak: "Do Not Know",
        },
        remarks: "Remarks",
        everLearntJapanese: "(b) Have you ever learnt Japanese?",
        everLearntJapaneseOptions: {
            yes: "Yes",
            no: "No",
        },
        learntJapaneseNote:
            "If Yes, please provide information below and attach a copy of the supporting document(s):",
        courseName: "Name of Course",
        attainedLevel: "Level Attained",
        startOrCompletionDate: "Start / Completion Date",
        schoolName: "Name of School",
        schoolAddress: "School Address",
        schoolTel: "Tel No.",
        schoolFax: "Fax No.",
        positionHeld: "Position Held",
        positionHeldOptions: {
            assistantPrincipal: "Assistant Principal",
            seniorTeacher: "Senior Teacher",
            teacher: "Teacher",
        },
        presentSchoolDate: "Date to Present School",
        presentPostDate: "Date to Present Post",
        taughtTitle:
            "Subject(s) Taught in Senior Classes in the Current School Year",
        taughtSubject: "Subject(s) Taught",
        taughtLevel: "Level Taught",
        taughtRemarks: "Remarks",
        headTitle:
            "Non-teaching Duties (Class Teacher / Club Adviser / Activity Coordinator, etc.)",
        headPosition: "Position Held",
        natureOfDuty: "Nature of Duty",
        period: "Period",
        periodFrom: "Start Date",
        periodTo: "Completion Date",
        headRemarks: "Remarks",
        experienceTitle:
            "Other Working Experience (including non-teaching experience and overseas working experience)",
        instituteName: "Name of Organisation",
        nameRemark: "Name (as appeared in the HKSAR Passport)",
        englishName: "English",
        chineseName: "Chinese",
        chineseCodeName: "Name (Chinese Character Code)",
        birthDate: "Date of Birth",
        birthPlace: "Place of Birth",
        sex: "Sex",
        hkIDNo: "HKID No.",
        homeAddress: "Home Address",
        photoAttachment: "Upload a photo here",
        homeTel: "Contact Tel. No.",
        mobilePhone: "Mobile Phone No.",
        eMailAddress: "E-mail Address",
        faxNo: "Fax No.",
        hkSARPassportNumber: "Have you held a valid HKSAR Passport?",
        expiryDate: "Date of Expiry",
        issueDate: "Date of Issue",
        sexOption: {
            Male: "Male",
            Female: "Female",
        },
        hkPersonEnName: "Name (English)",
        hkPersonCnName: "Name (Chinese)",
        hkPersonRelationship: "Relationship with the Nominee",
        hkPersonAddress: "Address",
        hkPersonHomeTel: "Home Tel. No.",
        hkPersonMobliePhone: "Mobile Phone No.",
        hkPersonEmail: "E-mail Address",
        hkPersonFax: "Fax No.",
        exchangeProgrammePeriod: "Period",
        exchangeProgrammeHostingOrganization: "Hosting Organisation",
        exchangeProgrammePlace: "Place / Country Visited",
        exchangeProgrammePurpose: "Purpose of the Visit",
        exchangeProgrammeHostingRole: "Responsibilities",
        interestsOrHobbies: "Interests / Hobbies",
        achievements: "Achievements (relevant records, if any)",
        gotFirstAidTraining: "(a) Have you got first aid training?",
        gotFirstAidTrainingTitle:
            "If Yes, please provide the expiry date of the first aid certificate and attach a copy of the supporting document.",
        firstAidCertificateExpiryDate:
            "Expiry Date of the First Aid Certificate (dd / mm / yyyy)",
        trainUpStudentDelegatesArea:
            "(b) State in which area(s), e.g. simple Japanese, speech, choir, etc. that you can train up the student delegates.",
        supportingApplicationInformation:
            "(c) State any further information you consider useful in supporting your application, e.g. worked as Japanese interpreter, etc.",
        attendActivities:
            "(d) If you are selected, are you able to attend the activities which are held in the morning / afternoon at week-ends and late afternoon / evening on week days?",
        attendActivitiesOptions: {
            yes: "Yes",
            no: "No",
            notSure: "Not sure",
        },
        nomineeName: "Name of Nominee",
        nominationReasons: "My nomination is based on the following reasons",
        principalName: "Name of Principal",
        contactTel: "Contact Tel. No.",
        nomineeSign: "Signature of Nominee",
        presentPost: "Present Post",
        hasPassNoTips: "If YES, please provide the expiry date of HKSAR Passport:",
        passNoExpireDate: "Expiry Date of HKSAR Passport (dd / mm / yyyy)"
    },
    options: {
        hasPassNoOp: {
            yes: "Yes",
            no: "No",
        }
    },
    errorMsg: {
        englishName: "English Name",
        chineseName: "Chinese Name",
    },
    note: {
        note1: "(a) School should submit the nomination form(s) and relevant documents <b>{{deadline}}.</b> School may submit the completed nomination form and upload the support documents via the Common Log-on system (https://clo.edb.gov.hk/).",
        note2: "(b) Information given in this form will be used for processing application for the JENESYS Programme.",
        note3: `(c) One recent full-face photograph of the nominee uploaded to this form is required.`,
        note4: "(d) Failure to provide information / documents as required may result in the application being declined.",
        note5: "(1) The personal data provided in this form will be used by the Education Bureau for one or more of the following purpose(s):",
        note6: "(a) processing application for the JENESYS Programme; and",
        note7: "(b) conducting related research and compiling statistics to facilitate planning of related education services.",
        note8: "(2) The provision of personal data by means of this form is obligatory.  Failure to provide these data may affect the processing and outcome of your application.",
        note9: "(3) The personal data collected in this form may be disclosed to other government departments / bureaux or the receiving parties for the purposes mentioned above.",
        note10: "(4) You have a right to request access to and correction of your personal data as provided for in Section 18 and 22 and Principle 6 of Schedule 1 of the Personal Data (Privacy) Ordinance.  Your right of access includes the right to obtain a copy of your personal data provided in this form.  This is however subject to payment of a fee.",
        note11: "(5) Enquiries concerning the personal data collected by means of this form, including making of access and corrections, should be addressed to the Extended Support Programmes Section, the Education Bureau, Room 1141, 11/F, Wu Chung House, 213 Queen’s Road East, Wanchai, Hong Kong (Tel. No.: 2892 6663).",
        note12: "(a) I declare that the information provided above is true and correct.",
        note13: "(b) If selected, I undertake to:",
        note14: "be responsible and be committed to serve as a role model for student-delegates;",
        note15: "attend all pre-tour meetings, training sessions, briefing sessions, rehearsals, etc.;",
        note16: "plan for the talent shows and conduct training programmes for the student-delegates;",
        note17: "lead student-delegates to prepare relevant materials on Hong Kong for presentation to the receiving parties;",
        note18: "assist in the administrative work, logistic arrangement and rehearsals of the delegation prior to departure;",
        note19: "lead a group of student-delegates and carry out the related duties as a teacher-chaperon;",
        note20: "take care of the student-delegates and deal with their discipline and behavioral problem during the exchange visit;",
        note21: "complete an individual evaluation form after the exchange visit;",
        note22: "guide the student-delegates in completing the group report on the outcome of the exchange visit within one and a half months after the visit;",
        note23: "complete a report about the exchange visit and share my experience on how I can facilitate student-delegates to learn from the JENESYS Programme within two months after the visit; and",
        note24: "attend relevant functions as and when invited or requested by EDB or the sponsor.",
        note25: "Completed nomination form together with the following documents should be submitted:",
        note26: "(a) A recent full-face photograph;",
        note27: "(b) Copies of any other documents that are useful in supporting the application;",
        note28: "(c) A copy of the supporting document(s) of proficiency in / studying of Japanese, if any; and.",
        note29: "(d) A copy of the first aid certificate, if any.",
    },
};

export default Form011EN;

